import React, { useEffect, useState } from 'react';
import logo from './logo.svg';

const HomeScreen = () => {
  const [backgroundColor, setBackgroundColor] = useState('#926E6E');
  
  useEffect(() => {
    const colors = [
      '#926E6E', '#92776E', '#92806E', '#92896E', '#91926E', 
      '#88926E', '#7F926E', '#76926E', '#6E926E', '#6E9277',
      '#6E9280', '#6E9289', '#6E9292', '#6E8992', '#6E8092',
      '#6E7792', '#6E6E92', '#776E92', '#806E92', '#896E92'
    ];
    
    let index = 0;
    const interval = setInterval(() => {
      setBackgroundColor(colors[index]);
      index = (index + 1) % colors.length;
    }, 50);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-full transition-colors duration-500 ease-in-out p-5"
         style={{ backgroundColor }}>
      <div className="flex items-center justify-center mb-4">
        <img
          src={logo}
          className="w-6 h-6 mr-1"
          alt="logo"
        />
        <h1 className="text-4xl font-bold text-white font-roboto">
          Projekt69
        </h1>
      </div>
      <p className="text-lg text-white text-center max-w-xl font-roboto">
        Will be available soon on your App Store and Play Store
      </p>
    </div>
  );
};

export default HomeScreen;